import { render, staticRenderFns } from "./swt.vue?vue&type=template&id=c2c1a21a&scoped=true"
import script from "./swt.vue?vue&type=script&lang=js"
export * from "./swt.vue?vue&type=script&lang=js"
import style0 from "./swt.vue?vue&type=style&index=0&id=c2c1a21a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c1a21a",
  null
  
)

export default component.exports